import { PASSWORD_CONSTRAINTS } from '../../../../../constants/progressBanner'

export const validateEmail = async (
    email: string,
    touched: boolean,
    isDisabled: boolean
): Promise<string> => {
    if (isDisabled) return ''

    if (!email && touched) {
        return '入力してください'
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (email && !emailRegex.test(email)) {
        return '有効なメールアドレスを入力してください'
    }

    if (email) {
        try {
            const csrfToken = document.querySelector<HTMLMetaElement>(
                'meta[name="csrf-token"]'
            )?.content
            const response = await fetch('/api/v1/users/check_if_registered', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
                },
                body: JSON.stringify({
                    user: { email: email },
                }),
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()
            if (!data) {
                return 'このメールアドレスはすでに登録されています'
            }
        } catch {
            return 'サーバーとの通信に失敗しました'
        }
    }

    return ''
}

export const validatePassword = (
    password: string,
    touched: boolean
): string => {
    if (!password && touched) {
        return '入力してください'
    }
    if (password) {
        if (
            password.length < PASSWORD_CONSTRAINTS.MIN_LENGTH ||
            password.length > PASSWORD_CONSTRAINTS.MAX_LENGTH
        ) {
            return 'パスワードは8文字以上32文字以下で入力してください'
        }
        if (!/[A-Z]/.test(password)) {
            return '大文字を含めてください'
        }
        if (!/[a-z]/.test(password)) {
            return '小文字を含めてください'
        }
        if (!/[0-9]/.test(password)) {
            return '数字を含めてください'
        }
    }
    return ''
}

export const validateForm = async (
    email: string,
    password: string,
    touched: { email: boolean; password: boolean },
    isEmailDisabled: boolean
): Promise<{ errors: { email: string; password: string }; isValid: boolean }> => {
    const emailError = await validateEmail(email, touched.email, isEmailDisabled)
    const passwordError = validatePassword(password, touched.password)

    return {
        errors: {
            email: emailError,
            password: passwordError,
        },
        isValid: email !== '' && password !== '' && !emailError && !passwordError,
    }
}
